import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { failAlert } from "../../../common/alert";
import { updateProductFilters } from "../../../redux/action/productFiltersAction";

const SizeFilterWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  > span {
    margin-right: 10px;
  }
  .btn {
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    padding: 0 20px;
    border-radius: 10px;
  }

  @media (max-width: 991px) {
    justify-content: flex-start;
  }
  @media (max-width: 767px) {
    display: none;
  }
`;

const MobileSizeFilterWrapper = styled.div`
  display: none;
  flex-direction: column;

  & span {
    margin-right: 10px;
    text-align: end;
    font-size: 14px;
  }

  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  & button {
    border: none;
    background: #3bb77e;
    color: #fff;
    border-radius: 10px;
    font-size: 14px;
    word-break: keep-all;
    height: 30px;
    :hover {
      background-color: #fd7e14;
    }
  }

  @media (max-width: 767px) {
    display: grid;
  }
`;

const SizeInput = styled.input`
  max-width: 120px;
  height: 30px;
  text-align: center;
  padding: 0 10px;
  margin-right: 10px;
  @media (max-width: 767px) {
    font-size: 14px;
    width: 100%;
    max-width: none;
  }
`;

const SizeSelect = styled.select`
  width: fit-content;
  height: 30px;
  text-align: center;
  border: 1px solid #ececec;
  background-color: #fff;
  border-radius: 10px;
  margin-right: 10px;
  padding: 0px 20px;

  @media (max-width: 767px) {
    font-size: 14px;
    width: 100%;
    max-width: none;
  }
`;

// 사이즈 형식을 표시하는 레이블 컴포넌트 추가
const SizeFormatLabel = styled.div`
  display: flex;
  align-items: center;
  margin-right: 15px;
  font-size: 14px;
  color: #666;

  @media (max-width: 767px) {
    margin-bottom: 10px;
    font-size: 13px;
  }
`;

const SizeFilter = ({
  updateProductFilters,
  productFilters,
  handleSizeFilter,
  viewHeight,
  categorySizeSearch,
  selectedCategory,
}) => {
  const router = useRouter();
  const [selectedSizes, setSizes] = useState({
    horizontal: "", //가로
    vertical: "", //세로
    height: "", //높이
    range: "",
  });

  // 선택된 카테고리에 따라 필터 타입 결정
  const [filterType, setFilterType] = useState("default"); // default, box 등

  useEffect(() => {
    // 선택된 카테고리에 따라 필터 타입 설정
    if (selectedCategory) {
      // 여러 카테고리가 선택된 경우 (공백으로 구분)
      const categoryArray = selectedCategory.split(" ");

      // 박스 카테고리 확인 (01, 02, 10 중 하나라도 포함되면 박스 타입)
      const isBoxCategory = categoryArray.some(
        (cat) =>
          cat.startsWith("BOX") || cat === "01" || cat === "02" || cat === "10"
      );

      // 비닐봉투 카테고리 확인 (16, 17, 06)
      const isEnvelopeCategory = categoryArray.some(
        (cat) => cat === "16" || cat === "17" || cat === "06"
      );

      if (isBoxCategory) {
        // 박스 카테고리가 포함되어 있으면 박스 타입으로 설정
        setFilterType("box");
      } else {
        setFilterType("default");
      }
    }
  }, [selectedCategory, viewHeight]);

  // 페이지 진입 시 초기 값 설정
  useEffect(() => {
    updateProductFilters({
      ...productFilters,
      sizes: {
        horizontal: "",
        vertical: "",
        height: "",
        range: "",
      },
    });
    if (!router.query.sizes) {
      setSizes({
        horizontal: "",
        vertical: "",
        height: "",
        range: "",
      });
    }
  }, [router.query]);

  const handleFilter = () => {
    const hasValue = Object.entries(selectedSizes)
      .filter(([key]) => filterType === "box" || key !== "height") // 박스 타입이 아니면 height는 검사하지 않음
      .some(([, value]) => value > 0);

    if (!hasValue) {
      return failAlert("1개 이상의 조건을 입력해주세요.");
    }

    if (handleSizeFilter) {
      handleSizeFilter(selectedSizes);
    } else {
      updateProductFilters({
        sizes: selectedSizes,
        code: router.query.code,
        hash: router.query.hash || productFilters.hash,
      });
    }
  };

  const onChangeSize = (id) => (e) => {
    setSizes({ ...selectedSizes, [id]: e.target.value });
  };

  const handleInput = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setTimeout(() => {
        handleFilter();
      }, 200);
    }
  };

  const sizes = [0, 10, 20, 30, 40, 50, 60];

  return (
    <>
      <SizeFilterWrapper>
        <SizeInput
          onChange={onChangeSize("horizontal")}
          placeholder={"가로mm"}
          value={selectedSizes.horizontal}
          onKeyDown={handleInput}
        />
        <SizeInput
          onChange={onChangeSize("vertical")}
          placeholder={"세로mm"}
          value={selectedSizes.vertical}
          onKeyDown={handleInput}
        />
        {filterType === "box" && (
          <SizeInput
            onChange={onChangeSize("height")}
            placeholder={"높이mm"}
            value={selectedSizes.height}
            onKeyDown={handleInput}
          />
        )}
        <SizeSelect
          id="sizeFilter"
          name="sizeFilter"
          onChange={onChangeSize("range")}
          value={selectedSizes.range}
        >
          {sizes.map((el, i) => (
            <option value={el > 0 ? el : ""} key={i}>
              ± {el}
            </option>
          ))}
        </SizeSelect>
        <button className="btn" onClick={handleFilter}>
          사이즈 검색
        </button>
      </SizeFilterWrapper>
      <MobileSizeFilterWrapper>
        <SizeInput
          onChange={onChangeSize("horizontal")}
          placeholder={"가로"}
          value={selectedSizes.horizontal}
        />
        <SizeInput
          onChange={onChangeSize("vertical")}
          placeholder={"세로"}
          value={selectedSizes.vertical}
        />
        {filterType === "box" && (
          <SizeInput
            onChange={onChangeSize("height")}
            placeholder={"높이"}
            value={selectedSizes.height}
          />
        )}
        <SizeSelect
          id="sizeFilter"
          name="sizeFilter"
          onChange={onChangeSize("range")}
          value={selectedSizes.range}
        >
          {sizes.map((el, i) => (
            <option value={el > 0 ? el : ""} key={i}>
              ± {el}
            </option>
          ))}
        </SizeSelect>
        <button onClick={handleFilter}>사이즈 검색</button>
      </MobileSizeFilterWrapper>
    </>
  );
};

const mapStateToProps = (state) => ({
  productFilters: state.productFilters,
});

const mapDidpatchToProps = {
  updateProductFilters,
};

export default connect(mapStateToProps, mapDidpatchToProps)(SizeFilter);
